import React from 'react';

export default (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 6L16 16" stroke="#364159" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M16 6L6 16" stroke="#364159" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);
